import { render, staticRenderFns } from "./ResetPasswordProfile.vue?vue&type=template&id=f83ab720"
import script from "./ResetPasswordProfile.vue?vue&type=script&lang=js"
export * from "./ResetPasswordProfile.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordProfile.vue?vue&type=style&index=0&id=f83ab720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports